import React, { useState, useContext } from 'react';
import {
	Divider,
	IconButton,
	Menu,
	MenuItem,
	Typography,
	ListItemIcon,
	Box
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import dashboardStyles from '../Dashboard.style';
import { getDraftMenuListItem } from './MenuListItem';
import { UserPortalContext } from 'context/appcontext';
import { deepClone } from 'helper/helper';
import { useDispatch, useSelector } from 'react-redux';
import { getSavedReportsListSuccess } from '../Dashboard.actions';
import DialogBox from 'components/Shared/DialogBox';
import APIURLPATH from 'constants/apiconstants';
import RBSnackbar from 'components/Shared/RBSnackbar';
import { getData } from 'service/getData.service';
import { putData } from 'service/putData.service';
import {
	SAVED_RPT_MSG,
	PERSONA,
	FILTER_CONDITION_LABELS,
	CATMAN_CUSTOM_DATASET_IDS,
	PREVIEW_LOADING_MSG,
	NETWORK_ISSUE_MSG
} from 'constants/constant';
import {
	setSelectedTemplate,
	getTempatesSuccess,
	getTempatesFailure,
	getCustomAttributeSuccess,
	getCustomAttributeFailure,
	setCustomDatasetName
} from 'components/Template/Template.actions';
import { selectedTempDetials } from './utils/dashboard-utils';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import { getSelectedList } from './utils/report';
import { useNavigate } from 'react-router-dom';
import { editReport } from '../Dashboard.actions';
import {
	setSelectedList,
	draftPrevSelectedList,
	draftPrevFilterList,
	draftPrevPivotOption,
	setFilterList,
	saveDraftSuccess,
	loadPreviewData,
	setPrevSelectedList,
	setPrevFilterList,
	setMenu,
	saveItemShareStatus
} from 'components/Preview/Preview.actions';
import { getAuthHeader } from 'helper/authHeader';
import { getDfltFilter, getSavedCustomDatasetWithAttributes } from 'helper/utils';
import { build } from 'helper/build';

function DraftMenuList({ rowData, index }) {
	const navigate = useNavigate();
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, updateUserPersona } = portalUserContext;
	const { companyName, loginId, userPersona, blackOut } = userDetails?.result;
	const request = { companyName, loginId };
	const [anchorEl, setAnchorEl] = useState(null);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });
	const [openRenameDailog, setOpenRenameDialog] = useState(false);
	const [openDeleteDailog, setOpenDeleteDialog] = useState(false);
	const menuItemList = getDraftMenuListItem();
	const classes = dashboardStyles();
	const dispatch = useDispatch();

	const savedReportsList = useSelector((state) => state.dashboardReducer.savedReportsList);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const customAttribute = useSelector((state) => state.templateReducer.customAttribute);

	const { SUPPLIER, CATMAN, BASIC_CATMAN } = PERSONA;

	const handleOpen = (event) => {
		setSnackbar({ open: false, msg: '' });
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (event) => {
		event.stopPropagation();
		setAnchorEl(null);
	};

	const callRename = async (newRptName) => {
		const bodyData = {
			draftName: newRptName
		};

		const URL = `${APIURLPATH.MODIFY_NAME}${rowData.draftId}`;

		request['requestBody'] = bodyData;
		const status = await putData(URL, request);

		if (status.statusCode >= 400) {
			setSnackbar({ open: true, msg: SAVED_RPT_MSG.RENAME_FAILED, type: 'error' });
			setOpenRenameDialog(false);
			return;
		}

		let list = deepClone(savedReportsList);
		const idx = list.findIndex((item) => item.draftId === rowData.draftId);
		list[idx] = { ...list[idx], draftName: newRptName };
		dispatch(getSavedReportsListSuccess(list));

		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.RENAME_DRAFT} ${rowData?.templateName}`,
			location: PAGE_ID.DASHBOARD
		});

		setOpenRenameDialog(false);
	};

	const callDelete = async () => {
		const URL = `${APIURLPATH.DELETE_DRAFT}${rowData.draftId}`;
		const status = await getData(URL, request);
		if (status.statusCode >= 400) {
			setSnackbar({ open: true, msg: SAVED_RPT_MSG.DELETION_FAILED, type: 'error' });
			setOpenDeleteDialog(false);
			return;
		}

		let list = deepClone(savedReportsList);

		/** Remove from allDraft reducer */
		let idx = list.findIndex((item) => item.draftId === rowData.draftId);
		list.splice(idx, 1);
		dispatch(getSavedReportsListSuccess(list));

		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.DELETE_DRAFT} ${rowData?.templateName}`,
			location: PAGE_ID.DASHBOARD
		});

		setOpenDeleteDialog(false);
	};

	const callEdit = () => {
		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.EDIT_DRAFT} ${rowData?.templateName}`,
			location: PAGE_ID.DASHBOARD
		});
		setSnackbar({
			open: true,
			msg: PREVIEW_LOADING_MSG,
			type: 'success',
			hideDuration: 5000
		});

		navigateToPreview();
	};

	async function navigateToPreview() {
		let templateId = undefined;
		let selectedTemp = undefined;

		if (userPersona === CATMAN && rowData.reportType === SUPPLIER) {
			let url = `${APIURLPATH.VIEW_TYPE}SUPPLIER`;
			let customUrl = `${APIURLPATH.CUSTOM_ATTRIBUTES_TYPE}SUPPLIER`;

			const request = { companyName, loginId };
			const { headers } = getAuthHeader(request);
			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						...headers
					}
				});
				const customResponse = await fetch(customUrl, {
					method: 'GET',
					headers: {
						...headers
					}
				});

				if (response?.status >= 400 || customResponse?.status >= 400) {
					setSnackbar({
						open: true,
						msg: NETWORK_ISSUE_MSG,
						type: 'error',
						hideDuration: 5000
					});
					return;
				} else {
					let res = await response?.json();
					let customRes = await customResponse?.json();
					updateUserPersona(rowData.reportType);
					dispatch(getCustomAttributeSuccess(customRes));
					dispatch(getTempatesSuccess(res));
					res = res.map((item) => ({
						...item,
						customAttribute: customRes
					}));
					nextSteps(res);
				}
			} catch (error) {
				dispatch(getTempatesFailure(505));
				dispatch(getCustomAttributeFailure(505));
			}
		} else {
			nextSteps(templateData);
		}

		function nextSteps(tempData) {
			const _isItemShare = rowData.runQueryRequestObject.itemShare || false;

			const savedCustomDatasetWithAttributes = getSavedCustomDatasetWithAttributes(
				savedCustomDatasets,
				customDatasetDetails,
				customAttribute
			);
			const tmpData = [...cannedReportData, ...tempData, ...savedCustomDatasetWithAttributes];
			selectedTemp = tmpData.filter((item) => {
				const isCatmanCustomDS =
					CATMAN_CUSTOM_DATASET_IDS.includes(Number(rowData.templateId)) && userPersona === CATMAN;
				if (isCatmanCustomDS || rowData.templateId === customDatasetDetails.templateId) {
					return rowData?.customDatasetId === item?.customDatasetId;
				} else {
					return item.templateName === rowData.templateName;
				}
			})[0];
			dispatch(setCustomDatasetName({ datasetName: selectedTemp.customDatasetName }));

			templateId = rowData.templateId;
			if (Number(rowData.templateId) === Number(customDatasetDetails.templateId)) {
				templateId = rowData?.customDatasetId;
			}
			const appliedFilter = rowData?.filtersWithValue.filter(
				(item) => item.filter.condition !== ''
			);

			if (userPersona === 'MERCHANT' && !blackOut) {
				if (!appliedFilter.find((item) => sbuDBTechNames.includes(item.dbtechnicalName))) {
					const SBUdimension = selectedTemp.dimensions.filter((dim) =>
						sbuDBTechNames.includes(dim.dbtechnicalName)
					);

					const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;

					const dfltFiltersOnDimensions = [];
					SBUdimension.map((dim) => {
						dfltFiltersOnDimensions.push({
							dimension: dim,
							condition: SBUDfltCondition,
							value: sbuDepartments.map((dept) => dept.deptNum)
						});
					});
					const defaultFilterSel = getDfltFilter(templateData, dfltFiltersOnDimensions);

					defaultFilterSel.map((filter, index) => {
						if (sbuDBTechNames.includes(filter.dbtechnicalName)) {
							const field = build(defaultFilterSel[index], selectedView, userPersona);
							defaultFilterSel[index] = { ...defaultFilterSel[index], field };
							appliedFilter.push(defaultFilterSel[index]);
						}
					});
				}
			}

			const selectedList = getSelectedList(rowData, tmpData, templateId);
			const req = deepClone(rowData.runQueryRequestObject);

			dispatch(
				loadPreviewData({
					requestBody: req,
					editData: rowData
				})
			);
			dispatch(
				setSelectedTemplate(selectedTempDetials(rowData.runQueryRequestObject.view, selectedTemp))
			);
			dispatch(editReport({ isEditEnabled: true, editData: rowData, action: 'EDIT' }));
			dispatch(setSelectedList(selectedList));
			dispatch(setFilterList(appliedFilter));
			dispatch(draftPrevSelectedList(deepClone(selectedList)));
			dispatch(draftPrevFilterList(deepClone(rowData?.filtersWithValue)));
			dispatch(draftPrevPivotOption(rowData?.pivotColumn));
			dispatch(setPrevSelectedList(selectedList));
			dispatch(setPrevFilterList(appliedFilter));
			dispatch(saveDraftSuccess(rowData));
			dispatch(setMenu(undefined));
			dispatch(saveItemShareStatus({ prev: _isItemShare, curr: _isItemShare }));
			dispatch(getTempatesSuccess(tmpData));
			navigate('/preview');
		}
	}

	function handleOnClick(id) {
		const fn = {
			edit: () => {
				callEdit();
			},
			rename: () => {
				setOpenRenameDialog(true);
			},
			delete: () => {
				setOpenDeleteDialog(true);
			}
		};
		return fn[id]();
	}

	const RenameDialog = ({ data }) => {
		const dialogProps = {
			title: 'Rename',
			bodyContent: '',
			secondaryBtnText: 'Cancel',
			primaryBtnText: 'Save',
			onSecondaryClick: () => {
				setOpenRenameDialog(false);
			},
			onPrimaryClick: callRename,
			showTextBox: true,
			defaultTxtValue: data.draftName
		};
		dialogProps.hideBodyContent = true;
		return <DialogBox open={openRenameDailog} {...dialogProps} />;
	};

	const DeleteDialog = () => {
		const dialogProps = {
			title: 'Delete saved report?',
			bodyContent: '',
			secondaryBtnText: 'Cancel',
			primaryBtnText: 'Delete it',
			onSecondaryClick: () => {
				setOpenDeleteDialog(false);
			},
			onPrimaryClick: callDelete,
			showTextBox: false
		};
		dialogProps.hideBodyContent = true;
		return <DialogBox open={openDeleteDailog} {...dialogProps} />;
	};

	const shouldShowMenuOption = (item) => {
		if (item.id === 'create_report' && [CATMAN, BASIC_CATMAN].includes(userPersona)) {
			return false;
		}
		return true;
	};

	return (
		<>
			<IconButton id={`toolbar-options-${index}`} onClick={handleOpen}>
				<MoreVertIcon fontSize="medium" />
			</IconButton>
			<Menu
				id={`action-items`}
				anchorEl={anchorEl}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				className={classes.menu}
				elevation={1}
				MenuListProps={{
					'aria-labelledby': 'basic-button'
				}}
				open={Boolean(anchorEl)}
				onClose={handleClose}>
				{menuItemList.map((item, idx) => {
					if (shouldShowMenuOption(item)) {
						return (
							<Box key={`${item.name}-${idx}`}>
								<MenuItem
									id={`${item.name}-${idx}`}
									className={classes.menuItems}
									onClick={(e) => {
										handleOnClick(item.id, rowData);
										e.stopPropagation();
										setAnchorEl(null);
									}}>
									<ListItemIcon>{item.icon}</ListItemIcon>
									<Typography>{item.name}</Typography>
								</MenuItem>
								{item.divider && <Divider />}
							</Box>
						);
					}
				})}
			</Menu>
			<RenameDialog data={rowData} />
			<DeleteDialog />
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				doClose={() => {
					setSnackbar({ open: false, msg: '' });
				}}
				type={openSnackbar.type}
			/>
		</>
	);
}

export default DraftMenuList;
